import React from "react";
import { Route, Routes } from "react-router";
import StockList from "../pages/stock/StockList";
import CustomerList from "../pages/CustomerList";
import Login from "../pages/user/Login";
import AuthOutlet from "@auth-kit/react-router/AuthOutlet";
import AddStockItem from "../pages/stock/AddStockItem";
import AppContainer from "../Components/AppContainer";
import ItemList from "../pages/ItemList";
import CustomerDetails from "../pages/CustomerDetails";
import SalesList from "../pages/SalesList";
import UsersPage from "../pages/users";
import AddSalesPage from "../pages/AddSale/AddSalePage";
import CustomerSelect from "../pages/AddSale/CustomerSelect";
import AddInvoice from "../pages/AddSale";
import InvoiceViewPage from "../pages/AddSale/InvoiceViewPage";
import Expenses from "../pages/Expenses";
import StockLocationList from "../pages/StockLocations";
import AddBuyInvoice from "../pages/AddBuyInvoice";
import BuyInvoice from "../pages/BuyInvoice";
import BuyInvoices from "../pages/BuyInvoices";
import StockLocationItems from "../pages/StockLocations/items";
import ItemsBelowMinQuantity from "../pages/ItemsBelowMinQuantity";
import CustomerReportsList from "../pages/CustomerReportsList";
import CustomerReport from "../pages/CustomerReport";
import ItemsExpiringSoon from "../pages/ItemsExpiringSoon";
import EditInvoice from "../pages/EditInvoice";

const RoutesComponent = () => {
    return (
        <Routes>
            <Route path="/Login" element={<Login />} />
            <Route element={<AuthOutlet fallbackPath="/Login" />}>
                {/* <Route element={<Outlet />}> */}
                <Route
                    path="/"
                    element={
                        <AppContainer>
                            <AddSalesPage />
                        </AppContainer>
                    }
                />
                <Route
                    path="/StockList"
                    element={
                        <AppContainer>
                            <StockList />
                        </AppContainer>
                    }
                />
                <Route
                    path="/ItemList"
                    element={
                        <AppContainer>
                            <ItemList />
                        </AppContainer>
                    }
                />
                <Route path="/Invoice/:id" element={<InvoiceViewPage />} />
                <Route
                    path="/AddStockItem"
                    element={
                        <AppContainer>
                            <AddStockItem />
                        </AppContainer>
                    }
                />
                <Route
                    path="/CustomerList"
                    element={
                        <AppContainer>
                            <CustomerList />
                        </AppContainer>
                    }
                />
                <Route
                    path="/CustomerDetails/:id"
                    element={
                        <AppContainer>
                            <CustomerDetails />
                        </AppContainer>
                    }
                />
                <Route
                    path="/SalesList"
                    element={
                        <AppContainer>
                            <SalesList />
                        </AppContainer>
                    }
                />
                <Route
                    path="/StockLocationList"
                    element={
                        <AppContainer>
                            <StockLocationList />
                        </AppContainer>
                    }
                />
                <Route
                    path="/StockLocationItems/:stockLocationId"
                    element={
                        <AppContainer>
                            <StockLocationItems />
                        </AppContainer>
                    }
                />
                <Route
                    path="/AddSale"
                    element={
                        <AppContainer>
                            <AddSalesPage />
                        </AppContainer>
                    }
                />
                <Route
                    path="/AddBuyInvoice"
                    element={
                        <AppContainer>
                            <AddBuyInvoice />
                        </AppContainer>
                    }
                />
                <Route
                    path="/BuyInvoices"
                    element={
                        <AppContainer>
                            <BuyInvoices />
                        </AppContainer>
                    }
                />
                <Route
                    path="/BuyInvoices/:id"
                    element={
                        <AppContainer>
                            <BuyInvoice />
                        </AppContainer>
                    }
                />
                <Route
                    path="/SelectCustomer"
                    element={
                        <AppContainer>
                            <CustomerSelect />
                        </AppContainer>
                    }
                />
                <Route
                    path="/AddInvoice"
                    element={
                        <AppContainer>
                            <AddInvoice />
                        </AppContainer>
                    }
                />

                <Route
                    path="/Users"
                    element={
                        <AppContainer>
                            <UsersPage />
                        </AppContainer>
                    }
                />
                <Route
                    path="/Expenses"
                    element={
                        <AppContainer>
                            <Expenses />
                        </AppContainer>
                    }
                />
                <Route
                    path="/items-below-min-quantity"
                    element={
                        <AppContainer>
                            <ItemsBelowMinQuantity />
                        </AppContainer>
                    }
                />
                <Route
                    path="/customer-reports"
                    element={
                        <AppContainer>
                            <CustomerReportsList />
                        </AppContainer>
                    }
                />
                <Route
                    path="/customer-report/:id"
                    element={
                        <AppContainer>
                            <CustomerReport />
                        </AppContainer>
                    }
                />
                <Route
                    path="/items-expiring-soon"
                    element={
                        <AppContainer>
                            <ItemsExpiringSoon />
                        </AppContainer>
                    }
                />
                <Route
                    path="/EditInvoice/:id"
                    element={
                        <AppContainer>
                            <EditInvoice />
                        </AppContainer>
                    }
                />
                {/* </Route> */}
            </Route>
        </Routes>
    );
};

export default RoutesComponent;
